<template>
  <div class="prize-card">
    <pageTitle pageTitle="防录屏设置">
      <div class="title_text" v-if="isInWebinar">
        <p class="switch__box">
          <vh-switch
            v-model="playerOpen"
            active-color="#FB3A32"
            inactive-color="#CECECE"
            @change="closePlayerOpen"
            :active-text="reservationDesc"
          ></vh-switch>
          <span v-if="!isEmbed" class="tip-text" @click="toSettingDetail">
            查看账号下防录屏设置
          </span>
        </p>
      </div>
    </pageTitle>
    <div class="player-set" :class="activeName" style="min-height: 741px">
      <vh-tabs v-model="activeName" @tab-click="handleClick">
        <vh-tab-pane label="防录屏跑马灯" name="first">
          <div class="give-item">
            <div class="give-prize">
              <vh-form :model="formHorse" ref="ruleForm" :rules="rules" label-width="100px">
                <vh-form-item label="跑马灯">
                  <p class="switch__box">
                    <vh-switch
                      v-model="scrolling_open"
                      active-color="#ff4949"
                      inactive-color="#ccc"
                      @change="closeHorseInfo"
                      :active-text="horseLampText"
                    ></vh-switch>
                  </p>
                </vh-form-item>
                <vh-form-item label="显示方式">
                  <vh-radio
                    v-model="formHorse.scroll_type"
                    :label="1"
                    :disabled="!scrolling_open"
                    @change="editHorseInfo"
                  >
                    滚动
                  </vh-radio>
                  <vh-radio
                    v-model="formHorse.scroll_type"
                    :label="2"
                    :disabled="!scrolling_open"
                    @change="editHorseInfo"
                  >
                    闪烁
                  </vh-radio>
                </vh-form-item>
                <vh-form-item label="文本类型">
                  <vh-radio
                    v-model="formHorse.text_type"
                    :label="1"
                    :disabled="!scrolling_open"
                    @change="editHorseInfo"
                  >
                    固定文本
                  </vh-radio>
                  <vh-radio
                    v-model="formHorse.text_type"
                    :label="2"
                    :disabled="!scrolling_open"
                    @change="editHorseInfo"
                  >
                    观看者ID和昵称
                  </vh-radio>
                </vh-form-item>
                <vh-form-item label="固定文本">
                  <vh-input
                    v-model="formHorse.text"
                    class="textType"
                    placeholder="版权所有，盗版必究"
                    :disabled="!scrolling_open"
                    autocomplete="off"
                    :maxlength="20"
                    v-clearEmoij
                    show-word-limit
                    @change="editHorseInfo"
                  ></vh-input>
                </vh-form-item>
                <vh-form-item label="文字大小">
                  <vh-select
                    v-model="formHorse.size"
                    placeholder="请选择"
                    :disabled="!scrolling_open"
                    style="margin-bottom: 10px"
                    @change="editHorseInfo"
                  >
                    <vh-option
                      v-for="item in fontList"
                      :key="item.value"
                      :label="item.value"
                      :value="item.value"
                    ></vh-option>
                  </vh-select>
                </vh-form-item>
                <vh-form-item label="文字颜色" prop="color">
                  <color-set
                    ref="pageThemeColors"
                    :themeKeys="pageThemeColors"
                    :openSelect="true"
                    @color="pageStyleHandle"
                    :colorDefault="formHorse.color"
                  ></color-set>
                </vh-form-item>
                <vh-form-item label="不透明度">
                  <vh-slider
                    v-model="formHorse.alpha"
                    :disabled="!scrolling_open"
                    style="width: 315px"
                    @change="editHorseInfo"
                  ></vh-slider>
                  <span class="isNum">{{ formHorse.alpha }}%</span>
                </vh-form-item>
                <vh-form-item label="移动速度" v-if="formHorse.scroll_type == 1">
                  <vh-radio
                    v-model="formHorse.speed"
                    :label="10000"
                    :disabled="!scrolling_open"
                    @change="editHorseInfo"
                  >
                    慢
                  </vh-radio>
                  <vh-radio
                    v-model="formHorse.speed"
                    :label="6000"
                    :disabled="!scrolling_open"
                    @change="editHorseInfo"
                  >
                    中
                  </vh-radio>
                  <vh-radio
                    v-model="formHorse.speed"
                    :label="3000"
                    :disabled="!scrolling_open"
                    @change="editHorseInfo"
                  >
                    快
                  </vh-radio>
                </vh-form-item>
                <vh-form-item label="显示位置">
                  <vh-radio
                    v-model="formHorse.position"
                    :label="1"
                    :disabled="!scrolling_open"
                    @change="editHorseInfo"
                  >
                    随机
                  </vh-radio>
                  <vh-radio
                    v-model="formHorse.position"
                    :label="2"
                    :disabled="!scrolling_open"
                    @change="editHorseInfo"
                  >
                    上
                  </vh-radio>
                  <vh-radio
                    v-model="formHorse.position"
                    :label="3"
                    :disabled="!scrolling_open"
                    @change="editHorseInfo"
                  >
                    中
                  </vh-radio>
                  <vh-radio
                    v-model="formHorse.position"
                    :label="4"
                    :disabled="!scrolling_open"
                    @change="editHorseInfo"
                  >
                    下
                  </vh-radio>
                </vh-form-item>
                <vh-form-item label="间隔时间" prop="interval" v-if="formHorse.scroll_type == 1">
                  <vh-input
                    v-model="formHorse.interval"
                    :disabled="!scrolling_open"
                    maxlength="3"
                    @blur="blurChange"
                    oninput="this.value=this.value.replace(/[^0-9]/g, '')"
                    placeholder="默认20，支持输入范围1-300"
                  >
                    <i slot="suffix">秒</i>
                  </vh-input>
                </vh-form-item>
                <vh-form-item>
                  <vh-button
                    type="primary"
                    round
                    class="common-save length152"
                    v-preventReClick
                    :disabled="!scrolling_open"
                    @click="preFormHorse"
                  >
                    保存
                  </vh-button>
                </vh-form-item>
              </vh-form>
            </div>
            <div
              class="give-white"
              v-show="!(scrolling_open && playerOpen)"
              :class="playerOpen ? 'webinarTop' : 'userTop'"
            ></div>
          </div>
        </vh-tab-pane>
        <vh-tab-pane label="水印设置" name="second">
          <div class="give-item waterSet">
            <div class="give-prize">
              <!-- 播放器水印设置表单 -->
              <vh-form
                :model="formWatermark"
                class="player-wm-form"
                :class="[{ 'has-mask': !playerWatermarkOpen }]"
                label-width="100px"
              >
                <vh-form-item label="播放器水印">
                  <p class="switch__box">
                    <vh-switch
                      v-model="playerWatermarkOpen"
                      active-color="#ff4949"
                      inactive-color="#ccc"
                      @change="handlePlayerWatermarkSwitch"
                      :active-text="waterMarkText"
                    ></vh-switch>
                  </p>
                </vh-form-item>
                <vh-form-item label="显示方式">
                  <vh-radio-group v-model="watermark_type" @change="handlePlayerWatermarkType">
                    <vh-radio :label="1">图片</vh-radio>
                    <vh-radio :label="2">文本</vh-radio>
                  </vh-radio-group>
                </vh-form-item>
                <vh-form-item label="水印图片" v-show="watermark_type == 1">
                  <upload
                    v-model="formWatermark.img_url"
                    :domain_url="domain_url"
                    :saveData="{
                      path: 'interacts/watermark-imgs',
                      type: 'image'
                    }"
                    :heightImg="130"
                    :widthImg="231"
                    :on-success="uploadAdvSuccess"
                    :on-progress="uploadProcess"
                    :on-error="uploadError"
                    :on-preview="uploadPreview"
                    :before-upload="beforeUploadHnadler"
                    :disabled="!playerWatermarkOpen"
                    @delete="deleteImg"
                  >
                    <div slot="tip">
                      <p>建议尺寸：240*80px，小于2M</p>
                      <p>支持jpg、gif、png、bmp</p>
                    </div>
                  </upload>
                </vh-form-item>
                <vh-form-item label="水印大小" v-show="watermark_type == 1">
                  <vh-radio-group @change="changeImgSize" v-model="formWatermark.img_size">
                    <vh-radio
                      v-for="(item, index) in imgSize"
                      :key="index"
                      :label="item.value"
                      :disabled="!playerWatermarkOpen"
                    >
                      {{ item.label }}
                    </vh-radio>
                  </vh-radio-group>
                </vh-form-item>
                <vh-form-item label="水印位置" v-show="watermark_type == 1">
                  <vh-radio
                    v-model="formWatermark.img_position"
                    :label="1"
                    :disabled="!playerWatermarkOpen"
                  >
                    左上角
                  </vh-radio>
                  <vh-radio
                    v-model="formWatermark.img_position"
                    :label="2"
                    :disabled="!playerWatermarkOpen"
                  >
                    右上角
                  </vh-radio>
                  <vh-radio
                    v-model="formWatermark.img_position"
                    :label="4"
                    :disabled="!playerWatermarkOpen"
                  >
                    左下角
                  </vh-radio>
                  <vh-radio
                    v-model="formWatermark.img_position"
                    :label="3"
                    :disabled="!playerWatermarkOpen"
                  >
                    右下角
                  </vh-radio>
                </vh-form-item>
                <vh-form-item label="不透明度" v-show="watermark_type == 1">
                  <vh-slider
                    v-model="formWatermark.img_alpha"
                    style="width: 315px"
                    :disabled="!playerWatermarkOpen"
                  ></vh-slider>
                  <span class="isNum">{{ formWatermark.img_alpha }}%</span>
                </vh-form-item>
                <vh-form-item label="文本类型" v-show="watermark_type == 2">
                  <vh-radio-group v-model="formWatermark.text_watermark.text_type">
                    <vh-radio :label="1">固定文本</vh-radio>
                    <vh-radio :label="2">观看者ID和昵称</vh-radio>
                  </vh-radio-group>
                </vh-form-item>
                <vh-form-item label="固定文本" v-show="watermark_type == 2">
                  <vh-input
                    v-model="formWatermark.text_watermark.text_value"
                    class="textType"
                    placeholder="版权所有，盗版必究"
                    :disabled="!playerWatermarkOpen"
                    autocomplete="off"
                    :maxlength="20"
                    v-clearEmoij
                    show-word-limit
                  ></vh-input>
                </vh-form-item>
                <vh-form-item label="文字大小" v-show="watermark_type == 2">
                  <vh-select
                    v-model="formWatermark.text_watermark.size"
                    placeholder="请选择"
                    :disabled="!playerWatermarkOpen"
                    style="margin-bottom: 10px"
                  >
                    <vh-option
                      v-for="item in fontList"
                      :key="item.value"
                      :label="item.value"
                      :value="item.value"
                    ></vh-option>
                  </vh-select>
                </vh-form-item>
                <vh-form-item label="文字颜色" v-show="watermark_type == 2">
                  <color-set
                    ref="pageThemeColorsPlayerText"
                    :themeKeys="pageThemeColors"
                    :openSelect="true"
                    @color="pageStyleHandlePlayerText"
                    :colorDefault="formWatermark.text_watermark.color"
                  ></color-set>
                </vh-form-item>
                <vh-form-item label="不透明度" v-show="watermark_type == 2">
                  <vh-slider
                    v-model="formWatermark.text_watermark.alpha"
                    :disabled="!playerWatermarkOpen"
                    style="width: 315px"
                  ></vh-slider>
                  <span class="isNum">{{ formWatermark.text_watermark.alpha }}%</span>
                </vh-form-item>
                <vh-form-item label="多行水印" v-show="watermark_type == 2">
                  <vh-radio-group v-model="formWatermark.text_watermark.line_mode">
                    <vh-radio :label="1">单行</vh-radio>
                    <vh-radio :label="2">多行</vh-radio>
                  </vh-radio-group>
                </vh-form-item>
                <vh-form-item label="旋转水印" v-show="watermark_type == 2">
                  <vh-radio-group v-model="formWatermark.text_watermark.orientation">
                    <vh-radio :label="1">倾斜</vh-radio>
                    <vh-radio :label="2">水平</vh-radio>
                  </vh-radio-group>
                </vh-form-item>
              </vh-form>
              <!-- 分割线 -->
              <vh-divider style="color: #e6e6e6; margin-bottom: 24px"></vh-divider>
              <!-- 文档水印设置表单 -->
              <vh-form
                :model="docMarkOption"
                class="doc-wm-form"
                :class="[{ 'has-mask': !docMark_open }]"
                label-width="100px"
              >
                <vh-form-item label="文档水印">
                  <p class="switch__box">
                    <vh-switch
                      v-model="docMark_open"
                      active-color="#ff4949"
                      inactive-color="#ccc"
                      @change="closeWaterDocInfo"
                      :active-text="docMarkText"
                    ></vh-switch>
                  </p>
                </vh-form-item>
                <vh-form-item label="文本类型" required>
                  <vh-checkbox
                    v-model="docMarkOption.doc_watermark_type.text"
                    :true-label="1"
                    :false-label="0"
                    :disabled="!docMark_open"
                    @change="editDocWaterInfo"
                  >
                    固定文本
                  </vh-checkbox>
                  <vh-checkbox
                    v-model="docMarkOption.doc_watermark_type.user_id"
                    :true-label="1"
                    :false-label="0"
                    :disabled="!docMark_open"
                    @change="editDocWaterInfo"
                  >
                    观看者ID
                  </vh-checkbox>
                  <vh-checkbox
                    v-model="docMarkOption.doc_watermark_type.nick_name"
                    :true-label="1"
                    :false-label="0"
                    :disabled="!docMark_open"
                    @change="editDocWaterInfo"
                  >
                    观看者昵称
                  </vh-checkbox>
                </vh-form-item>
                <vh-form-item label="固定文本">
                  <vh-input
                    v-model="docMarkOption.doc_watermark_type.text_value"
                    class="textType"
                    placeholder="版权所有，盗版必究"
                    :disabled="!docMark_open || !docMarkOption.doc_watermark_type.text"
                    autocomplete="off"
                    :maxlength="20"
                    v-clearEmoij
                    show-word-limit
                    @change="editDocWaterInfo"
                  ></vh-input>
                </vh-form-item>
                <vh-form-item label="文字大小">
                  <vh-select
                    v-model="docMarkOption.size"
                    placeholder="请选择"
                    :disabled="!docMark_open"
                    style="margin-bottom: 10px"
                    @change="editDocWaterInfo"
                  >
                    <vh-option
                      v-for="item in fontList"
                      :key="item.value"
                      :label="item.value"
                      :value="item.value"
                    ></vh-option>
                  </vh-select>
                </vh-form-item>
                <vh-form-item label="文字颜色" prop="color">
                  <color-set
                    ref="pageThemeColorsDoc"
                    :themeKeys="pageThemeColors"
                    :openSelect="true"
                    @color="pageStyleHandleDoc"
                    :colorDefault="docMarkOption.color"
                  ></color-set>
                </vh-form-item>
                <vh-form-item label="不透明度">
                  <vh-slider
                    v-model="docMarkOption.alpha"
                    :disabled="!docMark_open"
                    style="width: 315px"
                    @change="editDocWaterInfo"
                  ></vh-slider>
                  <span class="isNum">{{ docMarkOption.alpha }}%</span>
                </vh-form-item>
              </vh-form>
              <!-- 水印设置底部保存按钮 -->
              <div style="padding-left: 100px">
                <vh-button
                  type="primary length152"
                  v-preventReClick
                  round
                  class="common-save"
                  :disabled="!(playerWatermarkOpen || docMark_open)"
                  @click="preWatermark(1)"
                >
                  保存
                </vh-button>
              </div>
            </div>
          </div>
        </vh-tab-pane>
        <vh-tab-pane name="third" v-if="showThirdTab">
          <span slot="label">
            下载文档水印设置
            <vh-tooltip
              class="item"
              effect="dark"
              content="设置后导出PDF格式的数据带有水印。仅限于「报名表单」数据导出"
              placement="right"
            >
              <i class="iconfont-v3 saasicon_help_m" style="color: #999999"></i>
            </vh-tooltip>
          </span>
          <div class="PdfWatermark">
            <div class="give-white" v-show="!playerOpen"></div>
            <PdfWatermark></PdfWatermark>
          </div>
        </vh-tab-pane>
      </vh-tabs>
      <div class="show-purple" v-show="activeName !== 'third'">
        <div class="video-wrap">
          <div
            id="videoDom"
            :class="{
              player_no_bulletChat: !formOther.bulletChat,
              player_no_doubleSpeed: !formOther.doubleSpeed,
              player_no_progress: !formOther.progress,
              player_no_autoplay: !formOther.autoplay
            }"
          ></div>
        </div>
        <p class="show-purple-info">
          <span>提示</span>
          <span>1.移动端全屏播放时，跑马灯会失效；</span>
          <span>2.安卓手机浏览器劫持可能导致跑马灯失效；</span>
          <span>
            3.因浏览器自身策略，开启自动播放后可能会出现视频自动静音播放的情况，此时观看页会出现「开启音量并调节声音大小」的提示。微信和企微环境内不支持自动播放。
          </span>
          <span>4.分组直播不支持使用跑马灯、水印及弹幕，默认关闭跑马灯、水印及弹幕功能。</span>
          <span>5.竖屏直播的移动观看端不支持展示跑马灯、水印及弹幕，pc观看端不受影响</span>
        </p>
      </div>
      <div class="docMark" v-if="activeName == 'second'">
        <img src="../../../common/images/playerTitle.png" />
        <div class="preview">
          <div class="mark" v-if="docMark_open">
            <div
              v-for="i of 100"
              :key="'mark' + i"
              :style="{
                color: docMarkOption.color,
                fontSize: docMarkOption.size + 'px',
                height: docMarkOption.size * 3 + 'px',
                marginTop: docMarkOption.size + 'px',
                opacity: docMarkOption.alpha / 100
              }"
            >
              <span v-for="i of 20" :key="'mark-' + i">
                {{ docMarkOption.docMarkTxt.substring(0, 20) }}
              </span>
            </div>
          </div>
        </div>
        <div class="alert">
          <span>提示：</span>
          <span>
            1.设置了文档水印后，文字内容将以水印的形式出现在文档区域中，目前支持PC端、移动wap端；
          </span>
          <span>2.文档水印最多显示20个字，超出的水印内容将不会显示；</span>
          <span>
            3.非无延迟直播选择【合并模式】后，未上麦的观众端无法显示水印。
            <a
              v-if="isInWebinar"
              href="javascript:void(0);"
              class="safe__link"
              @click="toLivingSetPage"
            >
              去设置
            </a>
          </span>
        </div>
      </div>
      <!-- <div class="cut-line" v-if="activeName == 'second'"></div> -->
    </div>
    <begin-play
      :webinarId="$route.params.str"
      v-if="$route.query.type != 5 && webinarState != 4 && isInWebinar"
    ></begin-play>

    <vh-dialog title="提示" :before-close="closeDialog" :visible.sync="dialogVisible" width="400px">
      <div class="delay-content">
        当前直播活动为分组直播，暂不支持设置跑马灯、水印、弹幕功能。以上功能仅生效于回放状态。
      </div>
      <span slot="footer" class="dialog-footer">
        <vh-button size="medium" type="primary" round @click="closeDialog">我知道了</vh-button>
      </span>
    </vh-dialog>
  </div>
</template>

<script>
  import PageTitle from '@/components/PageTitle';
  import upload from '@/components/Upload/main';
  import ColorSet from '@/components/ColorSelect';
  import { sessionOrLocal, isEmbed, jump, safeJsonParse } from '@/utils/utils';
  import beginPlay from '@/components/beginBtn';
  import { paas_record_id_propagandaVideo } from '@/init-global/businessData';
  import controle from './js/control';
  import PdfWatermark from './components/PdfWatermark.vue';

  export default {
    name: 'safeScreenSet',
    mixins: [controle],
    data() {
      const intervalValidate = (rule, value, callback) => {
        if (!value) {
          callback(new Error('间隔时间不能为空'));
        } else {
          if (value < 1) {
            callback(new Error('间隔时间需大于0'));
          } else {
            callback();
          }
        }
      };
      this.$Vhallplayer = null;
      this.playerWatermarkPlugin = null;
      return {
        isEmbed: isEmbed(),
        showDelay: false,
        showGroupLive: false,
        webinarState: JSON.parse(sessionOrLocal.get('webinarState')),
        perssionWebInfo: JSON.parse(sessionOrLocal.get('SAAS_VS_PES', 'localStorage')),
        activeName: 'first',
        playerOpen: true, // 活动下状态，总开关
        scrolling_open: false,
        docMark_open: false,
        hasDelayPremission: false, // 活动下状态
        webinar_type: 0, // 活动下状态
        speed: 1,
        speedText: '倍速',
        speedList: [
          {
            label: '0.5x',
            value: 0.5
          },
          {
            label: '1.0x',
            value: 1
          },
          {
            label: '1.25x',
            value: 1.25
          },
          {
            label: '1.5x',
            value: 1.5
          },
          {
            label: '2.0x',
            value: 2
          }
        ],
        pageThemeColors: ['FFFFFF', 'BFBFBF', '1A1A1A', 'FB3A32', 'FFB201', '16C973', '3562FA'],
        formHorse: {
          color: '#BFBFBF', // 六位
          text_type: 2,
          size: 12,
          speed: 6000,
          text: '版权所有，盗版必究',
          position: 1,
          alpha: 100,
          scroll_type: 1,
          interval: 20
        },
        fontList: [],
        watermark_open: false, // 播放器图片类型的水印开关（原播放器水印开关,增加文本水印后，为了兼容之前的设置）
        text_watermark_open: false, // 播放器文本类型水印开关
        watermark_type: 1, // 当前选中的播放器水印类型：1.图片，2.文本 (仅用于控制台，在播放器水印开关关闭情况下，保持上一次选中的类型)
        // 播放器水印设置信息
        formWatermark: {
          img_position: 2,
          img_url: '',
          img_alpha: 100,
          img_size: 2,
          // 播放器文本水印配置信息
          text_watermark: {
            text_type: 1, //文本类型：1.固定文本，2.观看者id和昵称
            text_value: '版本所有，盗版必究', //显示文本内容
            size: 12, //文字大小
            color: '#BFBFBF', //文字颜色
            alpha: 100, //不透明度(0-100)
            line_mode: 1, //水印行样式：1.单行，2.多行
            orientation: 1 //水印方向：1.倾斜，2.水平
          }
        },
        domain_url: '',
        formOther: {
          progress: true,
          bulletChat: false,
          doubleSpeed: false,
          autoplay: false
        },
        videoParam: {
          paas_record_id:
            process.env.VUE_APP_NODE_ENV === 'production' || process.env.VUE_APP_NODE_ENV === 'pre'
              ? paas_record_id_propagandaVideo['production']
              : paas_record_id_propagandaVideo['test']
        },
        marqueeOption: {
          enable: Boolean(this.scrolling_open),
          text: '版权所有，盗版必究',
          alpha: 100, // 透明度  100 完全显示   0 隐藏
          size: 20, // 文字大小
          color: '#FFFFFF', //  文字颜色
          interval: 20, // 下次跑马灯开始与本次结束的时间间隔 ， 秒为单位
          speed: 6000, // 跑马灯移动速度  3000快     6000中   10000慢
          displayType: 0,
          position: 1
        },
        // 文档水印设置信息
        docMarkOption: {
          enable: Boolean(this.docMark_open),
          doc_watermark_type: {
            text: 0, //固定文本
            user_id: 1, //观看者ID
            nick_name: 0, //观看者昵称
            text_value: '版权所有，盗版必究' //固定文本内容
          },
          alpha: 50, // 透明度  100 完全显示   0 隐藏
          size: 12, // 文字大小
          color: '#5a5a5a' //  文字颜色
        },
        rules: {
          interval: [{ required: true, validator: intervalValidate, trigger: 'blur' }]
        },
        vm: null,
        checkEnter: true, // 检验是否是第一次进来的
        audioImg: require('@/common/images/logo4.png'),
        appId: '',
        appToken: '',
        imgSize: [
          {
            label: '大',
            value: 1
          },
          {
            label: '中',
            value: 2
          },
          {
            label: '小',
            value: 3
          }
        ],

        // 是否有下载文档水印设置的权限(admin配置)
        hasDownloadPdf: false,
        parentId: -1, // 父账户id, >0则表示当前是子账号
        childPermission: {} //子账号权限,只限制子账号
      };
    },
    components: {
      PageTitle,
      upload,
      ColorSet,
      beginPlay,
      PdfWatermark
    },
    watch: {
      watermark_type() {
        this.updatePlayerWatermarkPreview();
      },
      playerWatermarkOpen() {
        this.updatePlayerWatermarkPreview();
      },
      formWatermark: {
        handler() {
          this.updatePlayerWatermarkPreview();
        },
        deep: true
      },
      isInWebinar(val) {
        if (!val) {
          this.playerOpen = true;
        }
      }
    },
    computed: {
      // true：活动下，false：账号下
      isInWebinar() {
        return this.$route.path.indexOf('/live/safeScreenSet') > -1;
      },
      horseLampText() {
        if (this.scrolling_open) {
          return '已开启，文字以跑马灯的形式出现在播放器画面中';
        } else {
          return '开启后，文字以跑马灯的形式出现在播放器画面中';
        }
      },
      waterMarkText() {
        if (this.watermark_open) {
          return '已开启，可在播放器中增加图片、水印';
        } else {
          return '开启后，可在播放器中增加图片、水印';
        }
      },
      docMarkText() {
        if (this.docMark_open) {
          return '已开启，可在文档上增加文字水印';
        } else {
          return '开启后，可在文档上增加文字水印';
        }
      },
      reservationDesc() {
        if (this.playerOpen) {
          return '已开启，使用当前活动的防录屏设置';
        } else {
          return '开启后，使用当前活动的防录屏设置';
        }
      },
      reservationDisable() {
        if (this.perssionWebInfo['player_config'] > 0) {
          return false;
        } else {
          return true;
        }
      },
      dialogVisible() {
        if (this.webinar_type == 6 && this.showGroupLive) {
          return true;
        } else {
          return false;
        }
      },
      showThirdTab() {
        if (
          this.hasDownloadPdf &&
          (this.parentId == 0 ||
            (this.parentId > 0 && this.childPermission?.permission_operating_watermark))
        ) {
          return true;
        }
        return false;
      },
      // 播放器水印总开关（实际上接口没有这个字段,是通过图片开关和文本开关综合判断的）
      playerWatermarkOpen: {
        get() {
          // 图片开关和文本开关有一个开启就开启
          return !!(this.watermark_open || this.text_watermark_open);
        },
        set(newValue) {
          if (newValue) {
            // 开启
            if (this.watermark_type == 2) {
              this.watermark_open = false;
              this.text_watermark_open = true;
            } else {
              this.watermark_open = true;
              this.text_watermark_open = false;
            }
          } else {
            // 关闭，全部关闭
            this.watermark_open = false;
            this.text_watermark_open = false;
          }
        }
      }
    },
    async mounted() {
      this.userId = JSON.parse(sessionOrLocal.get('userId'));
      this._reportData = {
        business_uid: this.userId,
        user_id: '',
        webinar_id: '',
        refer: '',
        s: '',
        report_extra: {},
        ref_url: '',
        req_url: ''
      };
      if (this.isInWebinar) {
        this._reportData.webinar_id = this.$route.params.str;
      }
      this.getFontList();

      // 初始化admin配置的用户权限（非活动权限）
      this.initAdminUserPermission();

      if (this.isInWebinar) {
        await this.getLiveBaseInfo();
        await this.getPermission();
      }
      await this.getBasescrollingList();
      await this.getBaseWaterList();
      // 获取其他信息
      await this.getBaseOtherList();
      await this.getVideoAppid();
      this.initPlayer();
    },
    beforeDestroy() {
      if (this.$Vhallplayer) {
        this.$Vhallplayer.destroy();
      }
    },
    methods: {
      changeImgSize(value) {},
      closeDialog() {
        if (this.webinar_type == 6) {
          this.showGroupLive = false;
        } else {
          this.showDelay = false;
        }
      },
      getLiveBaseInfo() {
        // webinar/info调整-与活动状态无关的调用
        let dataRes = this.$fetch('getWebinarInfo', { webinar_id: this.$route.params.str })
          .then(res => {
            if (res.code != 200) {
              return this.$vhMessage.warning(res.msg);
            }
            this.webinar_type = res.data.webinar_type;
            this.showDelay = res.data.no_delay_webinar == 1 ? true : false;
            this.showGroupLive = res.data.webinar_type == 6 ? true : false;
          })
          .catch(res => {
            this.$vhMessage({
              message: res.msg || '获取信息失败',
              showClose: true,
              type: 'error',
              customClass: 'zdy-info-box'
            });
            console.log(res);
          });
        return dataRes;
      },

      // 获取配置项
      getPermission() {
        let dataRes = this.$fetch('planFunctionGet', {
          webinar_id: this.$route.params.str,
          webinar_user_id: this.userId,
          scene_id: 1
        })
          .then(res => {
            if (res.code == 200) {
              let permissions = JSON.parse(res.data.permissions);
              this.playerOpen = permissions['is_player_cofig'] > 0 ? true : false;
              this.hasDelayPremission = permissions['no.delay.webinar'] == 1;
              console.log('permissions:', permissions);
              this.hasDownloadPdf = !!permissions['download_pdf'];
            }
          })
          .catch(e => {});
        return dataRes;
      },
      blurChange() {
        if (!this.formHorse.interval || this.formHorse.interval < 0) {
          this.formHorse.interval = 20;
        }
        this.editHorseInfo();
      },
      closePlayerOpen() {
        if (this.reservationDisable && !this.playerOpen) {
          this.playerOpen = true;
          this.$vhAlert(
            '尊敬的用户，您的账号无此权限。如需使用，请联系您的客户经理或专属售后，也可拨打400-888-9970转2咨询',
            '提示',
            {
              confirmButtonText: '我知道了',
              customClass: 'zdy-message-box',
              lockScroll: false,
              callback: action => {}
            }
          );
          return;
        }
        let params = {
          webinar_id: this.$route.params.str,
          permission_key: 'is_player_cofig',
          status: Number(this.playerOpen)
        };
        console.log('当前参数传递：', params);
        this.$fetch('planFunctionEdit', params)
          .then(res => {
            this.$vhall_paas_port({
              k: this.playerOpen ? 100227 : 100228,
              data: this._reportData
            });
            this.getBasescrollingList();
            this.getBaseWaterList();
            this.getBaseOtherList();
            if (!this.playerOpen) {
              this.$vhMessage({
                message: '正在使用账号下防录屏设置',
                showClose: true,
                type: 'warning',
                customClass: 'zdy-info-box'
              });
            }
          })
          .catch(res => {
            this.$vhMessage({
              message: res.msg || `操作失败`,
              showClose: true,
              type: 'error',
              customClass: 'zdy-info-box'
            });
          });
      },
      toSettingDetail() {
        if (this.reservationDisable) {
          this.$vhAlert(
            '尊敬的用户，您的账号无此权限。如需使用，请联系您的客户经理或专属售后，也可拨打400-888-9970转2咨询',
            '提示',
            {
              confirmButtonText: '我知道了',
              customClass: 'zdy-message-box',
              lockScroll: false,
              callback: action => {}
            }
          );
          return;
        }
        this.$vhall_paas_port({
          k: 100229,
          data: this._reportData
        });
        let { href } = this.$router.resolve({ path: '/setting/safeScreen' });
        window.open(href, '_blank');
      },
      // 获取appId
      getVideoAppid() {
        let dataRes = this.$fetch('getAppid').then(res => {
          this.appId = res.data.app_id;
          this.appToken = res.data.access_token;
        });
        return dataRes;
      },
      // 页面样式色值
      pageStyleHandle(color) {
        this.formHorse.color = color;
        this.editHorseInfo();
      },
      // 页面样式色值DOC
      pageStyleHandleDoc(color) {
        this.docMarkOption.color = color;
        this.editDocWaterInfo();
      },
      pageStyleHandlePlayerText(color) {
        this.formWatermark.text_watermark.color = color;
      },
      getFontList() {
        let num = 10;
        while (num <= 36) {
          this.fontList.push({ value: num });
          num = num + 2;
        }
      },
      // 关闭文档水印
      closeWaterDocInfo() {
        if (!this.docMark_open) {
          this.$vhall_paas_port({
            k: 100851,
            data: this._reportData
          });
          this.preWatermark(2);
        }
      },
      // 关闭跑马灯
      closeHorseInfo() {
        if (!this.scrolling_open) {
          this.$vhall_paas_port({
            k: 100231,
            data: this._reportData
          });
          this.preFormHorse();
        }
        this.editHorseInfo();
      },
      // 编辑跑马灯
      editHorseInfo() {
        this.getMarqueeOptionInfo();
        this.$Vhallplayer.editMarquee(this.marqueeOption);
      },
      // 播放器水印开关操作
      handlePlayerWatermarkSwitch() {
        // 关闭时需要调用接口保存；开启时不操作，后面由底部“保存”按钮统一保存
        if (!this.playerWatermarkOpen) {
          this.$vhall_paas_port({
            k: 100260,
            data: this._reportData
          });
          this.preWatermark(0);
        }
      },
      // 播放器水印显示方式变更
      handlePlayerWatermarkType(val) {
        if (val == 1) {
          this.watermark_open = true;
          this.text_watermark_open = false;
        } else if (val == 2) {
          this.text_watermark_open = true;
          this.watermark_open = false;
        }
      },
      // 更新播放器水印预览
      updatePlayerWatermarkPreview() {
        if (!this.playerWatermarkPlugin) {
          const playerPlugins = this.$Vhallplayer?.vhallplayer?.pluginInstance || [];
          const watermarkPlugin = playerPlugins.find(
            plugin => plugin?.constructor?.type === 'plugin_watermark'
          );
          this.playerWatermarkPlugin = watermarkPlugin;
        }
        if (this.playerWatermarkPlugin) {
          let userInfo = JSON.parse(sessionOrLocal.get('userInfo'));
          const opts = this.playerWatermarkPlugin._allConfig;
          opts['plugin_watermark'] = JSON.stringify({
            enable: this.playerWatermarkOpen, // 默认 false
            mode: this.watermark_type == 2 ? 'text' : 'image', // 模式：image-图片水印；text-文本水印
            url: this.domain_url || this.audioImg, // 水印图片的路径
            align: this.fromalAlign(this.formWatermark.img_position),
            position: ['20px', '20px'], // 对应的横纵位置，支持px,vh,vw,%
            size: this.getWaterImageSize(this.formWatermark.img_size), // 水印大小，支持px,vh,vw,%  默认 80 35
            alpha: this.formWatermark.img_alpha,
            textConfig: {
              content:
                this.formWatermark.text_watermark.text_type == 2
                  ? `${userInfo.user_id}-${userInfo.nick_name}`
                  : this.formWatermark.text_watermark.text_value, // 文本内容
              size: this.formWatermark.text_watermark.size + 'px', // 文字大小
              color: this.formWatermark.text_watermark.color, // 文字颜色
              opacity: this.formWatermark.text_watermark.alpha, // 不透明度(0-100)
              multiline: this.formWatermark.text_watermark.line_mode == 2 ? true : false, // 1-单行 2-多行
              degrees: this.formWatermark.text_watermark.orientation == 1 ? -45 : 0 // 1-倾斜；2-水平
            }
          });
          this.playerWatermarkPlugin.init(opts);
        }
      },
      // 文档水印编辑，实时更新水印
      editDocWaterInfo() {
        this.getDocOptionInfo();
      },
      getDocOptionInfo() {
        let userInfo = JSON.parse(sessionOrLocal.get('userInfo'));
        if (!this.docMarkOption.doc_watermark_type.text_value) {
          this.docMarkOption.doc_watermark_type.text_value = '版权所有，盗版必究';
        }

        let waterText = '';
        let waterText_arr = [];
        this.docMarkOption.doc_watermark_type.text &&
          waterText_arr.push(this.docMarkOption.doc_watermark_type.text_value);
        this.docMarkOption.doc_watermark_type.user_id &&
          userInfo?.user_id &&
          waterText_arr.push(userInfo.user_id);
        this.docMarkOption.doc_watermark_type.nick_name &&
          userInfo?.nick_name &&
          waterText_arr.push(userInfo.nick_name);
        waterText = waterText_arr.join('-');

        this.docMarkOption = Object.assign({}, this.docMarkOption, {
          docMarkTxt: waterText
        });
      },
      getMarqueeOptionInfo() {
        let userInfo = JSON.parse(sessionOrLocal.get('userInfo'));
        if (!this.formHorse.text) {
          this.formHorse.text = '版权所有，盗版必究';
        }
        this.marqueeOption = {
          enable: Boolean(this.scrolling_open), // 默认 false
          text:
            this.formHorse.text_type == 2
              ? `${userInfo.user_id}${userInfo.nick_name}`
              : this.formHorse.text, // 跑马灯的文字
          alpha: this.formHorse.alpha, // 透明度  100 完全显示   0 隐藏
          size: this.formHorse.size, // 文字大小
          color: this.formHorse.color || '#FFFFFF', //  文字颜色
          interval: this.formHorse.scroll_type == 1 ? this.formHorse.interval : 1, // 下次跑马灯开始与本次结束的时间间隔 ， 秒为单位
          speed: this.formHorse.speed || 6000, // 跑马灯移动速度  3000快     6000中   10000慢
          displayType: this.formHorse.scroll_type == 1 ? 0 : 1,
          position: this.formHorse.position
        };
      },
      // 获取跑马灯基本信息
      getBasescrollingList() {
        let params = {
          type: this.playerOpen && this.isInWebinar ? 1 : 2,
          webinar_id: this.playerOpen && this.isInWebinar ? this.$route.params.str : ''
        };
        let dataRes = this.$fetch('getScrolling', this.$params(params)).then(res => {
          if (res.code == 200) {
            this.formHorse = { ...res.data };
            this.scrolling_open = Boolean(res.data.scrolling_open);
            this.getMarqueeOptionInfo();
          }
          this.$nextTick(() => {
            this.$refs.pageThemeColors.initColor(this.formHorse.color);
          });
        });
        return dataRes;
      },
      // 获取水印基本信息
      getBaseWaterList() {
        let params = {
          type: this.playerOpen && this.isInWebinar ? 1 : 2,
          webinar_id: this.playerOpen && this.isInWebinar ? this.$route.params.str : ''
        };
        let dataRes = this.$fetch('getWatermark', this.$params(params)).then(res => {
          if (res.code == 200) {
            this.formWatermark = { ...res.data };
            this.formWatermark.img_alpha = Number(res.data.img_alpha);
            this.watermark_type = res.data.watermark_type;
            this.text_watermark_open = Boolean(res.data.text_watermark_open);
            const textWatermarkJson = safeJsonParse(res.data.text_watermark);
            this.formWatermark.text_watermark = Object.assign(
              {
                text_type: 1, //文本类型：1.固定文本，2.观看者id和昵称
                text_value: '版本所有，盗版必究', //显示文本内容
                size: 12, //文字大小
                color: '#BFBFBF', //文字颜色
                alpha: 100, //不透明度(0-100)
                line_mode: 1, //水印行样式：1.单行，2.多行
                orientation: 1 //水印方向：1.倾斜，2.水平
              },
              textWatermarkJson
            );

            this.domain_url = res.data.img_url;
            this.watermark_open = Boolean(res.data.watermark_open);
            this.docMark_open = Boolean(res.data.doc_watermark_open);
            this.docMarkOption = {
              enable: Boolean(this.docMark_open),
              doc_watermark_type: res.data.doc_watermark_type,
              alpha: res.data.doc_transparency === 0 ? 0 : res.data.doc_transparency || 100, // 透明度  100 完全显示   0 隐藏
              size: res.data.doc_font_size || 12, // 文字大小
              color: res.data.doc_font_color || '#5a5a5a'
            };
            console.log('this.formWatermark:', this.formWatermark);
            this.getDocOptionInfo();
            this.$nextTick(() => {
              this.$refs.pageThemeColorsPlayerText.initColor(
                this.formWatermark.text_watermark.color
              );
              this.$refs.pageThemeColorsDoc.initColor(this.docMarkOption.color);
            });
          }
        });
        return dataRes;
      },
      // 获取其他基本信息
      getBaseOtherList() {
        let params = {
          type: this.playerOpen && this.isInWebinar ? 1 : 2,
          webinar_id: this.playerOpen && this.isInWebinar ? this.$route.params.str : ''
        };
        let dataRes = this.$fetch('getOtherOptions', this.$params(params))
          .then(res => {
            if (res.code == 200) {
              this.formOther.bulletChat = Boolean(res.data.barrage_button);
              this.formOther.progress = Boolean(res.data.progress_bar);
              this.formOther.doubleSpeed = Boolean(res.data.speed);
              this.formOther.autoplay = Boolean(res.data.autoplay);
            }
          })
          .catch(res => {
            this.$vhMessage({
              message: res.msg || `获取信息失败`,
              showClose: true,
              // duration: 0,
              type: 'error',
              customClass: 'zdy-info-box'
            });
          });
        return dataRes;
      },
      // 保存跑马灯
      preFormHorse() {
        // 校验间隔时间的输入
        if (this.formHorse.interval > 300) {
          this.$vhMessage({
            message: `间隔时间只能输入1-300之间的数字`,
            showClose: true,
            type: 'error',
            customClass: 'zdy-info-box'
          });
          return false;
        }
        this.formHorse.webinar_id = this.isInWebinar ? this.$route.params.str : '';
        this.formHorse.interval = this.formHorse.interval || 10;
        this.formHorse.text = this.formHorse.text || '版权所有，盗版必究';
        this.formHorse.scrolling_open = Number(this.scrolling_open);
        this.formHorse.type = this.isInWebinar ? 1 : 2;
        let params = JSON.parse(JSON.stringify(this.formHorse));
        // if(params.text_type == 2){
        //   delete params.text
        // }
        this.$fetch('setScrolling', this.$params(params))
          .then(res => {
            this.setHorseReportData();
            this.$vhMessage({
              message: this.scrolling_open ? '跑马灯开启成功' : '跑马灯关闭成功',
              showClose: true,
              type: 'success',
              customClass: 'zdy-info-box'
            });
          })
          .catch(res => {
            this.$vhMessage({
              message: res.msg || '保存跑马灯失败',
              showClose: true,
              type: 'error',
              customClass: 'zdy-info-box'
            });
          });
      },
      // 设置账号下跑马埋点数据
      setUserHorseReportData() {
        let loactionArr = [100653, 100654, 100655, 100656];
        let fontArr = [
          100657, 100658, 100659, 100660, 100661, 100662, 100663, 100664, 100665, 100666, 100667,
          100668, 100669, 100670
        ];
        if (this.scrolling_open) {
          this.$vhall_paas_port({
            k: 100644,
            data: this._reportData
          });
        }
        this.$vhall_paas_port({
          k: this.formHorse.scroll_type == 1 ? 100647 : 100646,
          data: this._reportData
        });
        this.$vhall_paas_port({
          k: this.formHorse.text_type == 1 ? 100648 : 100649,
          data: this._reportData
        });
        this.$vhall_paas_port({
          k: this.formHorse.speed == 3000 ? 100652 : this.formHorse.speed == 6000 ? 100651 : 100650,
          data: this._reportData
        });
        this.$vhall_paas_port({
          k: loactionArr[this.formHorse.position - 1],
          data: this._reportData
        });
        this.$vhall_paas_port({
          k: fontArr[(this.formHorse.size - 10) / 2],
          data: this._reportData
        });
        this.$vhall_paas_port({
          k: 100671,
          data: this._reportData
        });
        this.$vhall_paas_port({
          k: 100672,
          data: {
            ...this._reportData,
            report_extra: { interval: this.formHorse.interval }
          }
        });
      },
      // 设置跑马埋点数据
      setHorseReportData() {
        if (this.isInWebinar) {
          this.setWebinarHorseReportData();
        } else {
          this.setUserHorseReportData;
        }
      },
      // 设置活动下跑马埋点数据
      setWebinarHorseReportData() {
        console.log(this.formHorse);
        let loactionArr = [100239, 100240, 100241, 100242];
        let fontArr = [
          100243, 100244, 100245, 100246, 100247, 100248, 100249, 100250, 100251, 100252, 100253,
          100254, 100255, 100256
        ];
        if (this.scrolling_open) {
          this.$vhall_paas_port({
            k: 100230,
            data: this._reportData
          });
        }
        this.$vhall_paas_port({
          k: this.formHorse.scroll_type == 1 ? 100233 : 100232,
          data: this._reportData
        });
        this.$vhall_paas_port({
          k: this.formHorse.text_type == 1 ? 100234 : 100235,
          data: this._reportData
        });
        this.$vhall_paas_port({
          k: this.formHorse.speed == 3000 ? 100238 : this.formHorse.speed == 6000 ? 100237 : 100236,
          data: this._reportData
        });
        this.$vhall_paas_port({
          k: loactionArr[this.formHorse.position - 1],
          data: this._reportData
        });
        this.$vhall_paas_port({
          k: fontArr[(this.formHorse.size - 10) / 2],
          data: this._reportData
        });
        this.$vhall_paas_port({
          k: 100257,
          data: this._reportData
        });
        this.$vhall_paas_port({
          k: 100258,
          data: {
            ...this._reportData,
            report_extra: { interval: this.formHorse.interval }
          }
        });
      },
      /**
       * 保存水印
       * @param index 0-关闭播放器水印 1-保存所有水印 2-关闭文档水印
       */
      preWatermark(index) {
        if (!this.domain_url && this.watermark_open && index == 1) {
          this.$vhMessage.error('水印图片不能为空');
          return;
        }
        if (
          this.text_watermark_open &&
          index == 1 &&
          this.formWatermark.text_watermark?.text_type == 1 &&
          !this.formWatermark.text_watermark?.text_value
        ) {
          this.$vhMessage.error('文本水印固定文本不能为空');
          return;
        }

        if (
          this.docMark_open &&
          this.docMarkOption.doc_watermark_type.text +
            this.docMarkOption.doc_watermark_type.user_id +
            this.docMarkOption.doc_watermark_type.nick_name ===
            0 &&
          index == 1
        ) {
          this.$vhMessage.error('文本类型不能为空');
          return;
        }
        let params = {};
        if (index === 0) {
          if (!this.playerWatermarkOpen) {
            this.formWatermark.img_url = this.$parseURL(this.domain_url).path;
            this.formWatermark.watermark_open = Number(this.watermark_open);
            this.formWatermark.type = this.isInWebinar ? 1 : 2;
            params = Object.assign(
              {},
              {
                webinar_id: this.isInWebinar ? this.$route.params.str : '',
                watermark_open: this.formWatermark.watermark_open,
                type: this.isInWebinar ? 1 : 2,
                img_url: this.formWatermark.img_url,
                img_alpha: this.formWatermark.img_alpha,
                img_position: this.formWatermark.img_position,
                text_watermark_open: Number(this.text_watermark_open),
                text_watermark: JSON.stringify(this.formWatermark.text_watermark)
              }
            );
          }
        } else if (index === 2) {
          if (!this.docMark_open) {
            params = Object.assign(
              {},
              {
                webinar_id: this.isInWebinar ? this.$route.params.str : '',
                type: this.isInWebinar ? 1 : 2,
                doc_watermark_open: Number(this.docMark_open),
                doc_watermark_type: JSON.stringify(this.docMarkOption.doc_watermark_type),
                doc_font_size: this.docMarkOption.size,
                doc_font_color: this.docMarkOption.color,
                doc_transparency: this.docMarkOption.alpha
              }
            );
          }
        } else {
          this.formWatermark.img_url = this.$parseURL(this.domain_url).path;
          this.formWatermark.watermark_open = Number(this.watermark_open);
          this.formWatermark.type = this.isInWebinar ? 1 : 2;
          params = Object.assign({}, this.formWatermark, {
            text_watermark_open: Number(this.text_watermark_open),
            text_watermark: JSON.stringify(this.formWatermark.text_watermark),
            doc_watermark_open: Number(this.docMark_open),
            doc_watermark_type: JSON.stringify(this.docMarkOption.doc_watermark_type),
            doc_font_size: this.docMarkOption.size,
            doc_font_color: this.docMarkOption.color,
            doc_transparency: this.docMarkOption.alpha,
            webinar_id: this.isInWebinar ? this.$route.params.str : ''
          });
        }
        this.$fetch('setWatermark', this.$params(params))
          .then(res => {
            if (index === 0) {
              //播放器水印
              this.$vhMessage({
                message: this.watermark_open ? '保存成功' : '播放器水印关闭成功',
                showClose: true,
                // duration: 0,
                type: 'success',
                customClass: 'zdy-info-box'
              });
            } else if (index === 2) {
              //文档水印
              this.$vhMessage({
                message: this.docMark_open ? '保存成功' : '文档水印关闭成功',
                showClose: true,
                // duration: 0,
                type: 'success',
                customClass: 'zdy-info-box'
              });
            } else if (index === 1) {
              //播放器水印
              this.$vhMessage({
                message: '保存成功',
                showClose: true,
                // duration: 0,
                type: 'success',
                customClass: 'zdy-info-box'
              });
              this.setWaterReportData();
            }
          })
          .catch(res => {
            this.$vhMessage({
              message: res.msg || '保存水印失败',
              showClose: true,
              // duration: 0,
              type: 'error',
              customClass: 'zdy-info-box'
            });
          });
      },
      setUserWaterReportData() {
        let loactionArr = [100675, 100676, 100678, 100677];
        if (this.watermark_open) {
          this.$vhall_paas_port({
            k: 100673,
            data: this._reportData
          });
        }
        if (this.docMark_open) {
          this.$vhall_paas_port({
            k: 100848,
            data: this._reportData
          });
        }
        this.$vhall_paas_port({
          k: loactionArr[this.formWatermark.img_position - 1],
          data: this._reportData
        });
        this.$vhall_paas_port({
          k: 100679,
          data: {
            ...this._reportData,
            report_extra: { alpha: this.formWatermark.img_alpha }
          }
        });
      },
      setWaterReportData() {
        if (this.isInWebinar) {
          this.setWebinarWaterReportData();
        } else {
          this.setUserWaterReportData();
        }
      },
      setWebinarWaterReportData() {
        let loactionArr = [100261, 100262, 100264, 100263];
        if (this.watermark_open) {
          this.$vhall_paas_port({
            k: 100259,
            data: this._reportData
          });
        }
        if (this.docMark_open) {
          this.$vhall_paas_port({
            k: 100849,
            data: this._reportData
          });
        }
        this.$vhall_paas_port({
          k: loactionArr[this.formWatermark.img_position - 1],
          data: this._reportData
        });
        this.$vhall_paas_port({
          k: 100265,
          data: {
            ...this._reportData,
            report_extra: { alpha: this.formWatermark.img_alpha }
          }
        });
      },
      //文案提示问题
      messageInfo() {
        this.vm = this.$vhMessage({
          showClose: true,
          duration: 2000,
          message: '设置成功',
          type: 'success',
          customClass: 'zdy-info-box'
        });
      },
      // 获取图片类型水印的大小
      getWaterImageSize(img_size) {
        let size = ['10%', '10%'];
        switch (img_size) {
          case 1:
            size = ['12%', '12%'];
            break;
          case 2:
            size = ['10%', '10%'];
            break;
          case 3:
            size = ['8%', '8%'];
            break;
          default:
            size = ['10%', '10%'];
        }
        return size;
      },
      // 初始化播放器
      initPlayer() {
        this.initSDK().then(() => {
          this.$Vhallplayer && this.$Vhallplayer.play();
          this.listen();
        });
      },
      // 删除图片
      deleteImg() {
        this.formWatermark.img_url = '';
        this.domain_url = '';
      },
      fromalAlign(val) {
        let text;
        switch (parseInt(val)) {
          case 1:
            text = 'tl';
            break;
          case 2:
            text = 'tr';
            break;
          case 4:
            text = 'bl';
            break;
          case 3:
            text = 'br';
            break;
        }
        return text;
      },
      initSDK() {
        const incomingData = {
          appId: this.appId, // 应用ID，必填
          accountId: this.userId || 1, // 第三方用户ID，必填
          token: this.appToken, // access_token，必填
          type: 'vod', // live 直播  vod 点播  必填
          videoNode: 'videoDom', // 播放器的容器， div的id 必填
          poster: '', // 封面地址  仅支持.jpg
          autoplay: true,
          vodOption: {
            recordId: this.videoParam.paas_record_id,
            forceMSE: false
          },
          marqueeOption: this.marqueeOption,
          watermarkOption: {
            enable: false, // 默认 false
            mode: 'image', // 模式：image-图片水印；text-文本水印
            url: this.domain_url || this.audioImg, // 水印图片的路径
            align: this.fromalAlign(this.formWatermark.img_position), // 图片的对其方式， tl | tr | bl | br 分别对应：左上，右上，左下，右下
            position: ['20px', '20px'], // 对应的横纵位置，支持px,vh,vw,%
            size: ['60px', '20px'], // 水印大小，支持px,vh,vw,%  默认 80 35
            alpha: this.formWatermark.img_alpha,
            textConfig: {
              content: '', // 文本内容
              size: '16px', // 文字大小
              color: '#fff', // 文字颜色
              opacity: 30, // 不透明度，0-100，默认30
              multiline: false, // 是否多行，默认单行
              degrees: 0 // 旋转度数，默认不旋转
            }
          },
          subtitleOption: {
            enable: true
          }
        };
        return new Promise(resolve => {
          console.log('======实例化播放器参数======', incomingData);
          window.VhallPlayer.createInstance(
            incomingData,
            event => {
              console.log('初始化实例成功', event);
              this.$Vhallplayer = event.vhallplayer;
              this.$Vhallplayer.openControls(false);
              this.$Vhallplayer.setVolume(0);
              if (this.formOther.doubleSpeed) {
                this.$Vhallplayer.setPlaySpeed(this.speed);
              }
              this.updatePlayerWatermarkPreview();
              this.$Vhallplayer.on(window.VhallPlayer.LOADED, () => {
                // 加载中
                resolve();
              });
            },
            e => {
              console.log('播放器创建实例失败', e, e.message);
              throw new Error(e.message);
            }
          );
        });
      },
      uploadAdvSuccess(res, file) {
        console.log(res, file);
        if (res.data) {
          let domain_url = res.data.domain_url || '';
          let file_url = res.data.file_url || '';
          this.formWatermark.img_url = file_url;
          this.domain_url = domain_url;
        }
      },
      beforeUploadHnadler(file) {
        console.log(file);
        const typeList = ['png', 'jpeg', 'gif', 'bmp'];
        console.log(file.type.toLowerCase());
        let typeArr = file.type.toLowerCase().split('/');
        const isType = typeList.includes(typeArr[typeArr.length - 1]);
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isType) {
          this.$vhMessage({
            message: `水印图片只能是 ${typeList.join('、')} 格式`,
            showClose: true,
            // duration: 0,
            type: 'error',
            customClass: 'zdy-info-box'
          });
          return false;
        }
        if (!isLt2M) {
          this.$vhMessage({
            message: `水印图片大小不能超过 2M`,
            showClose: true,
            // duration: 0,
            type: 'error',
            customClass: 'zdy-info-box'
          });
          return false;
        }
        return isType && isLt2M;
      },
      uploadProcess(event, file, fileList) {
        console.log('uploadProcess', event, file, fileList);
      },
      uploadError(err, file, fileList) {
        console.log('uploadError', err, file, fileList);
        this.$vhMessage({
          message: `水印图片上传失败`,
          showClose: true,
          // duration: 0,
          type: 'error',
          customClass: 'zdy-info-box'
        });
      },
      uploadPreview(file) {
        console.log('uploadPreview', file);
      },
      handleFileChange(file) {
        console.log(file);
      },
      handleClick(tab) {
        this.activeName = tab.name;
        if (this.activeName === 'third') {
          // 暂停
          this.$Vhallplayer && this.$Vhallplayer.pause();
        }
      },
      // 跳转进入直播间设置逻辑
      toLivingSetPage() {
        jump({
          path: `${this.isEmbed ? '/embed' : ''}/live/livingSet/${this.$route.params.str}`,
          query: { type: this.$route.query.type, isDelay: this.$route.query.isDelay }
        });
      },

      // 初始化用户权限
      initAdminUserPermission() {
        const SAAS_VS_PES = sessionOrLocal.get('SAAS_VS_PES', 'localStorage');
        let permissions = SAAS_VS_PES ? JSON.parse(SAAS_VS_PES) : null;
        this.hasDownloadPdf = permissions ? !!permissions['download_pdf'] : false;

        let userInfo = sessionOrLocal.get('userInfo');
        if (userInfo) {
          userInfo = JSON.parse(userInfo);
          this.parentId = userInfo.parent_id;
          if (this.parentId > 0) {
            // 有子账号
            this.initChildPermission();
          }
        }
      },
      initChildPermission() {
        this.$fetch('getChildPermission')
          .then(res => {
            console.log('getChildPermission', res);
            sessionOrLocal.set('SAAS_V3_SON_PS', JSON.stringify(res.data));
            this.childPermission = res.data;
          })
          .catch(err => {
            console.error(err);
            sessionOrLocal.removeItem('SAAS_V3_SON_PS');
            this.childPermission = {};
          });
      }
    }
  };
</script>

<style lang="less" scoped>
  #videoDom {
    width: 100%;
    height: 100%;
  }
  .prize-card {
    height: 100%;
    .title_text {
      .tip-text {
        font-size: 14px;
        margin-left: 20px;
        cursor: pointer;
        color: #3562fa;
        vertical-align: middle;
      }
    }

    .player-set {
      background: #fff;
      position: relative;
      border-radius: 4px;
      ::v-deep .vh-tabs__content {
        width: 50%;
        padding: 0;
      }
    }
    .player-set.third {
      ::v-deep .vh-tabs__content {
        width: 100%;
      }
    }

    .textType {
      width: 360px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .common-save {
      width: 160px;
      height: 40px;
      line-height: 15px;
    }
    .isNum {
      position: absolute;
      top: -2px;
      right: 0px;
      color: #fb3a32;
    }
    .give-item {
      padding: 40px 24px;
      display: flex;
      position: relative;
      ::v-deep .vh-form {
        position: relative;
        i {
          font-style: normal;
        }
      }
      .give-prize {
        width: 460px;
      }
      .give-show {
        width: 600px;
        height: 500px;
        flex: 1;
        border: 1px solid #ccc;
      }
      .give-white {
        position: absolute;
        top: 80px;
        width: 100%;
        bottom: 0;
        background: rgba(255, 255, 255, 0.5);
        z-index: 9;
      }

      .webinarTop {
        top: 80px;
      }
      .userTop {
        top: 20px;
      }
    }

    .block {
      height: 50px;
    }
    .waterSet {
      .player-wm-form.has-mask::after {
        content: '';
        position: absolute;
        top: 50px;
        right: 0;
        bottom: 0;
        left: 0;
        background: rgba(255, 255, 255, 0.5);
        z-index: 9;
      }

      .doc-wm-form.has-mask::after {
        content: '';
        position: absolute;
        top: 50px;
        right: 0;
        bottom: 0;
        left: 0;
        background: rgba(255, 255, 255, 0.5);
        z-index: 9;
      }
    }

    .show-purple {
      width: 400px;
      border-radius: 5px;
      position: absolute;
      top: 95px;
      left: 54%;
      img {
        width: 400px;
        height: 226px;
      }
      .video-wrap {
        position: relative;
        width: 400px;
        overflow: hidden;
        background: #000000;
        height: 226px;
        ::v-deep .vhallPlayer-brarage-component {
          display: none;
        }

        .player_no_bulletChat {
          ::v-deep .vhallPlayer-brarage-component {
            display: none;
          }
        }

        .player_no_doubleSpeed {
          ::v-deep .vhallPlayer-speed-component {
            display: none;
          }
        }

        .player_no_progress {
          ::v-deep .vhallPlayer-progress-box {
            display: none;
          }
        }
      }

      &-info {
        width: 100%;
        margin-top: 15px;
        span {
          display: block;
          color: #999;
          line-height: 20px;
          font-size: 14px;
        }
      }
    }
    .video-wrap {
      position: relative;
      .waterMark {
        position: absolute;
        width: 80px;
        height: 30px;
        &.position_1 {
          top: 10px;
          left: 8px;
        }
        &.position_2 {
          top: 10px;
          right: 8px;
        }
        &.position_3 {
          bottom: 40px;
          right: 8px;
        }
        &.position_4 {
          bottom: 40px;
          left: 8px;
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: scale-down;
        }
      }
      .active {
        bottom: 0px;
      }
    }
    .preview-video {
      position: absolute;
      top: -41px;
      left: 0;
    }
    .docMark {
      width: 400px;
      border-radius: 5px;
      position: absolute;
      top: 545px;
      left: 54%;

      > img {
        width: 400px;
        height: 16px;
        margin-bottom: -18px;
        z-index: 9;
        position: relative;
      }
      .preview {
        width: 400px;
        height: 264px;
        background: url('../../../common/images/waterMark.png') no-repeat center;
        background-size: contain;
        overflow: hidden;
        min-height: initial;
        .mark {
          width: 2100px;
          height: 1500px;
          transform-origin: center;
          transform: translate(-840px, -700px) rotate(-15deg) scale(0.4);
          div {
            text-align: center;
            display: inline-block;
            margin: 0 auto;
            display: flex;
            overflow: hidden;
            width: 100%;
            span {
              display: flex;
              align-items: flex-start;
              margin: 0 30px;
              min-width: fit-content;
              &:nth-child(odd) {
                align-items: flex-end;
              }
            }
          }
        }
      }
      .alert {
        width: 100%;
        margin-top: 15px;
        span {
          display: block;
          color: #999;
          line-height: 20px;
          font-size: 14px;
        }
        .safe__link {
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          text-align: justify;
          color: #4e76fb;
          margin-left: 8px;
          margin-right: 8px;
        }
      }
    }

    .PdfWatermark {
      .give-white {
        position: absolute;
        top: 20px;
        width: 100%;
        bottom: 0;
        background: rgba(255, 255, 255, 0.5);
        z-index: 9;
      }
    }
  }

  .cut-line {
    width: calc(100% - 96px);
    height: 1px;
    position: absolute;
    top: 520px;
    left: 48px;
    background-color: #e6e6e6;
  }

  /deep/ .div__sketch {
    left: -170px;
  }
</style>
